/** Map stable API error codes (and legacy English messages) to i18n keys. */

export type ErrorBody = {
  code?: string
  error?: string
  message?: string
}

export function extractErrorCode(body: unknown, fallback = 'request_failed'): string {
  if (!body || typeof body !== 'object') return fallback
  const b = body as ErrorBody
  if (b.code && typeof b.code === 'string') return b.code
  if (b.error && typeof b.error === 'string' && !b.error.includes(' ')) return b.error
  const msg = (b.message || b.error || '').toLowerCase()
  if (msg.includes('insufficient')) return 'insufficient_funds'
  if (msg.includes('invalid amount') || msg.includes('below minimum')) return 'invalid_amount'
  if (msg.includes('unauthorized') || msg.includes('login')) return 'unauthorized'
  if (msg.includes('suspended')) return 'account_suspended'
  if (msg.includes('not found')) return 'not_found'
  if (msg.includes('rate')) return 'rate_limited'
  return fallback
}

export function errorI18nKey(code: string, prefix = 'errors'): string {
  return `${prefix}.${code}`
}
